import type { CheckoutType } from '../types/checkout'

export const checkoutInitialValues: CheckoutType = {
  step: 'account',
  shippingMethods: [],
  wasShipMethodSelected: false,
  isAddingOrEditingShippingAddress: 'add',
  isBillingSameAsShipping: true,
  isUseStoreCredit: false,
  results: [],
  finalCart: undefined,
  shipToEmail: '',
  itineraryId: null,
  scenario: null,
  isRedirectingToThankYou: false,
}
